import React from 'react'

import { HeaderValuePicker } from 'components/Layout/List'

const ValuePicker = ({ value, options, onChange, translateLabel, ...props }) => {
  return (
    <HeaderValuePicker
      value={value}
      options={options}
      selectionKeys={{
        value: 'value',
        label: 'label',
      }}
      onChange={onChange}
      allowClear={false}
      search={!translateLabel}
      {...props}
    />
  )
}

export default ValuePicker
